import { Helmet } from "react-helmet-async";

const SITE_URL = "https://adhdrapidcare.com/";

export default function SEOHeader({
  title = "ADHD Rapid Care | Australia",
  description = "Fast ADHD assessment and consultations in Australia.",
  path = "/",
  image = `${SITE_URL}/og-image.jpg`,
  lang = "en-AU",
}) {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>

      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
